// import external dependencies
import 'jquery';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Controller, EffectFade } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Controller, EffectFade]);

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//
// Cards Carousels  
//

$(function () {
  // Logo Cards Carousel
  const swiperLogos = new SwiperCore('.swiper-trigger-logo', {
    slidesPerView: 'auto',
    watchOverflow: true,
    speed: 500,
    navigation: {
      nextEl: '.swiper-button.next',
      prevEl: '.swiper-button.previous',
    },
    watchSlidesProgress: true,
  });

   // Posts Cards Carousel
  const swiperPosts = new SwiperCore('.swiper-trigger-posts', {
    slidesPerView: 'auto',
    watchOverflow: true,
    speed: 500,
    navigation: {
      nextEl: '.swiper-button.next',
      prevEl: '.swiper-button.previous',
    },
    watchSlidesProgress: true,
  });
});